import { isEmpty, omit, each } from 'lodash';
import { makeActionCreator } from '../../utils/actionsUtils';

import {
    FAILURE_CONTACT_REQUEST_REASON,
    RECEIVE_CONTACT_REQUEST_REASON,
    REQUEST_CONTACT_REQUEST_REASON,
    REQUEST_FORM_SUBMIT_CONTACT_REQUEST,
    SUCCESS_FORM_SUBMIT_CONTACT_REQUEST,
    FAILURE_FORM_SUBMIT_CONTACT_REQUEST,
    RESET_FORM_SUBMIT_CONTACT_REQUEST
} from './constants';
import { CALL_API } from '../../middlewares/api';

export const ERROR_FORMDATA_EMPTY = 'formData param must not be empty or null or undefined !';

export const reset = makeActionCreator(RESET_FORM_SUBMIT_CONTACT_REQUEST);

export function fetchContactRequestReasonIfNeeded() {
    return {
        [CALL_API]: {
            endpoint: '/service-client/reason',
            types: [
                REQUEST_CONTACT_REQUEST_REASON,
                RECEIVE_CONTACT_REQUEST_REASON,
                FAILURE_CONTACT_REQUEST_REASON
            ],
            shouldCallAPI: state => shouldFetchContactRequestReason(state)
        }
    };
}

function shouldFetchContactRequestReason(state) {
    const reasons = state.contactrequest.contactrequestreasons;
    const fetching = state.contactrequest.fetching;

    if (fetching) {
        return false;
    } else if (isEmpty(reasons)) {
        return true;
    } else {
        return false;
    }
}
/**
 * Send contact request form to server
 * @param {FormData} formData
 */
export function sendContactRequest(formData, callback) {
    if (isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }

    // Convert request to form-data request that contains FILES + JSON BODY
    let files = formData.files;
    let dataset = omit(formData, 'files');

    let form = new FormData();
    each(files, file => form.append('files', file));
    form.append('body', new Blob([JSON.stringify(dataset)], { type: 'application/json' }));

    return {
        [CALL_API]: {
            endpoint: '/service-client',
            types: [
                REQUEST_FORM_SUBMIT_CONTACT_REQUEST,
                SUCCESS_FORM_SUBMIT_CONTACT_REQUEST,
                FAILURE_FORM_SUBMIT_CONTACT_REQUEST
            ],
            body: form,
            successCallback: (response, dispatch) => {
                if (callback) {
                    callback();
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/contactrequest/actions.js